module.exports = __webpack_public_path__ + "static/media/behind-the-waves.a6df07ee.jpg";